export const sessionIdLocalStorageKey = "engieCamSessionId"
